<template>
  <v-simple-table dense>
    <thead class="primary">
      <tr>
        <th colspan="2" class="font-size-14 white--text font-weight-medium px-4 py-3 cell">
          {{ label }}
        </th>
      </tr>
    </thead>
    <tbody class="primary-lighten-1">
      <tr v-for="(attribute, idx) in attributes" :key="idx">
        <td class="font-lighten-2--text font-weight-medium cell cell--td">{{ attribute.label }}:</td>
        <td class="font--text cell cell--td">{{ values[attribute.attribute] }}</td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  name: 'SidebarForm',
  props: {
    attributes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    label: {
      type: String,
    },
    values: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => ({
    isExpanded: false,
  }),
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__wrapper {
  td {
    @include border(bottom);
    &:first-child {
      @include border(left);
    }
    &:last-child {
      @include border(right);
    }
  }
  tbody tr:hover {
    background-color: map-get($colors, 'primary-lighten-2') !important;
  }
  tbody tr:last-child:hover td:first-child,
  tbody tr:last-child:hover td:last-child {
    border-radius: 0 !important;
  }
}
.cell {
  height: auto;
  line-height: 16px;
  word-break: break-word;
}
.cell--td {
  width: 50%;
  font-size: 12px !important;
  padding: 10px 16px !important;
}
</style>
